import React, {useState} from "react";
import {
    TouchableOpacity
} from "../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import Styles from "../../Styles";
import {Collapse} from "react-collapse";

const InfoItem = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const checkOpen = () => {
        const openFlag = props.toggle ? props.isOpen : isOpen;

        return openFlag;
    }

    const toggle = () => {
        if(props.toggle)
            props.toggle();
        else
            setIsOpen(!isOpen)
    }

    return <TouchableOpacity
        style={{ padding: "7px 0" }}
        onPress={toggle}
    >
        <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', fontSize: '1.4rem', ...props.titleStyle }}>
            {props.icon}
            {props.title}
        </div>
        <Collapse isOpened={checkOpen()}>
            <div style={{ color: '#555555', fontSize: '1.2rem' }}>
                {props.text}
            </div>
        </Collapse>
    </TouchableOpacity>;
}

export default InfoItem;